var map = {
	"./afb-color.svg": 640,
	"./alb-color.svg": 641,
	"./all.svg": 642,
	"./amb-color.svg": 643,
	"./arg.svg": 644,
	"./aus.svg": 645,
	"./bank-icon.svg": 646,
	"./bankdemo-color.svg": 647,
	"./bel.svg": 648,
	"./bimb-color.svg": 649,
	"./bkr-color.svg": 650,
	"./bpay-color.svg": 651,
	"./bra.svg": 652,
	"./bsn-color.svg": 653,
	"./can.svg": 654,
	"./checked-white.png": 655,
	"./cimb-color.svg": 656,
	"./cimb-icon.svg": 657,
	"./citi-color.svg": 658,
	"./cmr.svg": 659,
	"./crc.svg": 660,
	"./cro.svg": 661,
	"./den.svg": 662,
	"./ecu.svg": 663,
	"./eng.svg": 664,
	"./esp.svg": 665,
	"./esports-active-m.svg": 666,
	"./esports-m.svg": 667,
	"./fav-gray.png": 668,
	"./fav-icon-active.png": 669,
	"./fav-icon.png": 670,
	"./fav-red.png": 671,
	"./fra.svg": 672,
	"./game-icon.svg": 673,
	"./games-active-m.svg": 674,
	"./games-m.svg": 675,
	"./ger.svg": 676,
	"./gha.svg": 677,
	"./gxbank-color.svg": 678,
	"./hlb-color.svg": 679,
	"./hlb-icon.svg": 680,
	"./hsbc-color.svg": 681,
	"./irn.svg": 682,
	"./jpn.svg": 683,
	"./kor.svg": 684,
	"./ksa.svg": 685,
	"./kwh-color.svg": 686,
	"./latest-icon-active.png": 687,
	"./latest-icon.png": 688,
	"./lc-active-m.svg": 689,
	"./lc-icon.svg": 690,
	"./lc-m.svg": 691,
	"./lottery-active-m.svg": 692,
	"./lottery-icon.svg": 693,
	"./lottery-m.svg": 694,
	"./love.svg": 695,
	"./mar.svg": 696,
	"./mbb-color.svg": 697,
	"./mex.svg": 698,
	"./ned.svg": 699,
	"./ocbc-color.svg": 700,
	"./ocbc-icon.svg": 701,
	"./p2p-active-m.svg": 702,
	"./p2p-icon.svg": 703,
	"./p2p-m.svg": 704,
	"./pbb-color.svg": 705,
	"./pol.svg": 706,
	"./por.svg": 707,
	"./price-high.svg": 708,
	"./price-low.svg": 709,
	"./qat.svg": 710,
	"./rhb-color.svg": 711,
	"./rhb-icon.svg": 712,
	"./scb-color.svg": 713,
	"./sen.svg": 714,
	"./slot-active-m.svg": 715,
	"./slot-icon.svg": 716,
	"./slot-m.svg": 717,
	"./speed-active-m.svg": 718,
	"./speed-m.svg": 719,
	"./sport-active-m.svg": 720,
	"./sport-m.svg": 721,
	"./sports-icon.svg": 722,
	"./square-icon.svg": 723,
	"./srb.svg": 724,
	"./star.svg": 725,
	"./sui.svg": 726,
	"./tng-color.svg": 727,
	"./trx-icon.svg": 728,
	"./trx.svg": 729,
	"./tun.svg": 730,
	"./uefa-icon.svg": 731,
	"./uob-color.svg": 732,
	"./uru.svg": 733,
	"./usa.svg": 734,
	"./usdc.svg": 735,
	"./usdt.svg": 736,
	"./ustd-icon.svg": 737,
	"./wal.svg": 738,
	"./x33-logo-b.svg": 739,
	"./x33-square-icon.svg": 740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;